var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "chart-settings-modal",
      attrs: {
        visible: _vm.visible,
        title: "Grafik Ayarları - " + _vm.widget.title,
        width: "90%",
        footer: null,
        destroyOnClose: true,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "settings-container" },
        [
          _c("div", { staticClass: "header-section" }, [
            _c(
              "div",
              { staticClass: "left-actions" },
              [
                _c("a-input-search", {
                  staticStyle: { width: "250px" },
                  attrs: { placeholder: "Ara...", allowClear: "" },
                  on: { search: _vm.handleSearch },
                  model: {
                    value: _vm.searchQuery,
                    callback: function ($$v) {
                      _vm.searchQuery = $$v
                    },
                    expression: "searchQuery",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    attrs: {
                      placement: "bottomLeft",
                      trigger: "click",
                      overlayClassName: "table-filter-popover",
                    },
                    model: {
                      value: _vm.filterVisible,
                      callback: function ($$v) {
                        _vm.filterVisible = $$v
                      },
                      expression: "filterVisible",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      [
                        _c("TableFilter", {
                          attrs: { fields: _vm.fields, value: _vm.filters },
                          on: { input: _vm.onFiltersUpdated },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: {
                          classNames:
                            "" +
                            (_vm.filters.length > 0 ? "active-filters" : ""),
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("filter_alt"),
                        ]),
                        _vm._v(
                          "\n                        Filtre\n                        "
                        ),
                        _vm.filters.length > 0
                          ? _c("span", { staticClass: "filter-count" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.filters.length) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filters.length
                          ? _c(
                              "i",
                              {
                                staticClass: "material-icons clear-filters",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.clearFilters.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("close")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("a-divider", { staticStyle: { margin: "12px 0" } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-section" },
            [
              _c(
                "div",
                { staticClass: "preview-section" },
                [
                  !_vm.previewData
                    ? _c(
                        "div",
                        { staticClass: "loading-state" },
                        [
                          _c("a-spin"),
                          _vm._v(" "),
                          _c("div", [_vm._v("Grafik yükleniyor...")]),
                        ],
                        1
                      )
                    : _vm.previewData.error
                    ? _c("div", { staticClass: "error-state" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("error_outline"),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.previewData.message))]),
                      ])
                    : [
                        _vm.$_.get(_vm.previewSettings, "chartType") === "bar"
                          ? _c("bar-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm.$_.get(_vm.previewSettings, "chartType") ===
                              "line" ||
                            _vm.$_.get(_vm.previewSettings, "chartType") ===
                              "smooth-line"
                          ? _c("line-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm.$_.get(_vm.previewSettings, "chartType") ===
                            "stacked-bar"
                          ? _c("stacked-bar-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm.$_.get(_vm.previewSettings, "chartType") ===
                              "stacked-line" ||
                            _vm.$_.get(_vm.previewSettings, "chartType") ===
                              "stacked-line-100"
                          ? _c("stacked-line-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm.$_.get(_vm.previewSettings, "chartType") ===
                            "pie"
                          ? _c("pie-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm.$_.get(_vm.previewSettings, "chartType") ===
                            "donut"
                          ? _c("donut-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm.$_.get(_vm.previewSettings, "chartType") ===
                            "area"
                          ? _c("area-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm.$_.get(_vm.previewSettings, "chartType") ===
                              "stacked-area" ||
                            _vm.$_.get(_vm.previewSettings, "chartType") ===
                              "stacked-area-100"
                          ? _c("stacked-area-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm.$_.get(_vm.previewSettings, "chartType") ===
                            "bubble"
                          ? _c("bubble-chart", {
                              attrs: {
                                data: _vm.previewData,
                                settings: _vm.previewSettings,
                                title: _vm.widget.title,
                                fields: _vm.fields,
                              },
                            })
                          : _vm._e(),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("a-divider", {
                staticStyle: { height: "100%", margin: "0 12px" },
                attrs: { type: "vertical" },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c(
                    "a-form",
                    { attrs: { form: _vm.form, layout: "vertical" } },
                    [
                      _c(
                        "a-collapse",
                        {
                          staticClass: "chart-type-collapse",
                          attrs: { defaultActiveKey: ["1"] },
                        },
                        [
                          _c(
                            "a-collapse-panel",
                            { key: "1", attrs: { header: "Grafik tipi" } },
                            [
                              _c(
                                "div",
                                { staticClass: "chart-type-selector" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "chart-type-category" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("En popüler")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "chart-type-options" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "pie",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "pie"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/pie.svg",
                                                  alt: "Pasta Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Pasta")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "bar",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "bar"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/bar.svg",
                                                  alt: "Sütun Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Sütun")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "line",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "line"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/line.svg",
                                                  alt: "Çizgi Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Çizgi")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-bar",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-bar"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/stacked-bar.svg",
                                                  alt: "Yığılmış Sütun Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Sütun")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "bubble",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "bubble"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/bubble.svg",
                                                  alt: "Kabarcık Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Kabarcık")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chart-type-category" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("Pasta")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "chart-type-options" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "pie",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "pie"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/pie.svg",
                                                  alt: "Pasta Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Pasta")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "donut",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "donut"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/donut.svg",
                                                  alt: "Halka Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Halka")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chart-type-category" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("Çizgi")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "chart-type-options" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "line",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "line"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/line.svg",
                                                  alt: "Çizgi Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Çizgi")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "smooth-line",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "smooth-line"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/smooth-line.svg",
                                                  alt: "Yumuşak Çizgi Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yumuşak Çizgi")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-line",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-line"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/stacked-line.svg",
                                                  alt: "Yığılmış Çizgi Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Çizgi")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "chart-type-option d-none",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-line-100",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-line-100"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/stacked-line.svg",
                                                  alt: "Yığılmış Çizgi %100 Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Çizgi %100")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chart-type-category" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("Sütun")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "chart-type-options" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "bar",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "bar"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/bar.svg",
                                                  alt: "Sütun Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Sütun")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-bar",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-bar"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/stacked-bar.svg",
                                                  alt: "Yığılmış Sütun Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Sütun")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "chart-type-option d-none",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-bar-100",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-bar-100"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/stacked-bar.svg",
                                                  alt: "Yığılmış Sütun %100 Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Sütun %100")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chart-type-category" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("Kolon")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "chart-type-options" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "bar",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "bar"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  transform: "rotate(90deg)",
                                                },
                                                attrs: {
                                                  src: "/static/img/tables/bar.svg",
                                                  alt: "Kolon Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Kolon")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-bar",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-bar"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  transform: "rotate(90deg)",
                                                },
                                                attrs: {
                                                  src: "/static/img/tables/stacked-bar.svg",
                                                  alt: "Yığılmış Kolon Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Kolon")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "chart-type-option d-none",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-column-100",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-column-100"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  transform: "rotate(90deg)",
                                                },
                                                attrs: {
                                                  src: "/static/img/tables/stacked-bar.svg",
                                                  alt: "Yığılmış Kolon %100 Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Kolon %100")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chart-type-category" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("Alan")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "chart-type-options" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "area",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "area"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/area.svg",
                                                  alt: "Alan Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Alan")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-area",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-area"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/stacked-area.svg",
                                                  alt: "Yığılmış Alan Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Alan")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "chart-type-option d-none",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType ===
                                                  "stacked-area-100",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "stacked-area-100"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/stacked-area.svg",
                                                  alt: "Yığılmış Alan %100 Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Yığılmış Alan %100")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "chart-type-category" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "category-title" },
                                        [_vm._v("Kabarcık")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "chart-type-options" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "chart-type-option",
                                              class: {
                                                active:
                                                  _vm.previewSettings
                                                    .chartType === "bubble",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleChartTypeChange(
                                                    "bubble"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: "/static/img/tables/bubble.svg",
                                                  alt: "Kabarcık Grafiği",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "option-name" },
                                                [_vm._v("Kabarcık")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: "X Ekseni" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                value: _vm.$_.get(
                                  _vm.previewSettings,
                                  "xAxis.field"
                                ),
                                placeholder: "Alan seçiniz",
                              },
                              on: { change: _vm.handleXAxisFieldChange },
                            },
                            _vm._l(
                              _vm.isBubbleChart
                                ? _vm.numericFields
                                : _vm.fields,
                              function (field) {
                                return _c(
                                  "a-select-option",
                                  {
                                    key: field._id,
                                    attrs: { value: field._id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(field.name) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isBubbleChart
                        ? _c(
                            "a-form-item",
                            { attrs: { label: "Kabarcık Boyutu" } },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    value: _vm.$_.get(
                                      _vm.previewSettings,
                                      "bubble.sizeField"
                                    ),
                                    placeholder: "Sayısal alan seçiniz",
                                  },
                                  on: {
                                    change: _vm.handleBubbleSizeFieldChange,
                                  },
                                },
                                _vm._l(_vm.numericFields, function (field) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: field._id,
                                      attrs: { value: field._id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(field.name) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isStackedChart
                        ? _c(
                            "a-form-item",
                            { staticClass: "stack-settings w-100" },
                            [
                              _c("div", { staticClass: "section-label" }, [
                                _vm._v("Gruplama Alanı:"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    value: _vm.$_.get(
                                      _vm.previewSettings,
                                      "stackBy.field"
                                    ),
                                    placeholder: "Alan seçiniz",
                                  },
                                  on: { change: _vm.handleStackByFieldChange },
                                },
                                _vm._l(_vm.fields, function (field) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: field._id,
                                      attrs: { value: field._id },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(field.name) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _vm.showStackModeAndExpand
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "stack-mode-section" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "section-label" },
                                          [_vm._v("Gruplama Şekli:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-button-group",
                                          [
                                            _c(
                                              "a-button",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center align-items-center gap-5",
                                                attrs: {
                                                  type:
                                                    _vm.$_.get(
                                                      _vm.previewSettings,
                                                      "stackBy.stackMode",
                                                      "stacked"
                                                    ) === "stacked"
                                                      ? "primary"
                                                      : "default",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleStackModeChange(
                                                      "stacked"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("layers")]
                                                ),
                                                _vm._v(
                                                  "\n                                        Üst Üste\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-button",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center align-items-center gap-5",
                                                attrs: {
                                                  type:
                                                    _vm.$_.get(
                                                      _vm.previewSettings,
                                                      "stackBy.stackMode",
                                                      "stacked"
                                                    ) === "grouped"
                                                      ? "primary"
                                                      : "default",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleStackModeChange(
                                                      "grouped"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("view_column")]
                                                ),
                                                _vm._v(
                                                  "\n                                        Yan Yana\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "expand-mode-section" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "section-label" },
                                          [_vm._v("Grafik Yönü:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-button-group",
                                          [
                                            _c(
                                              "a-button",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center align-items-center gap-5",
                                                attrs: {
                                                  type:
                                                    _vm.$_.get(
                                                      _vm.previewSettings,
                                                      "stackBy.expandMode",
                                                      "vertical"
                                                    ) === "vertical"
                                                      ? "primary"
                                                      : "default",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleExpandModeChange(
                                                      "vertical"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("bar_chart")]
                                                ),
                                                _vm._v(
                                                  "\n                                        Dikey\n                                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-button",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center align-items-center gap-5",
                                                attrs: {
                                                  type:
                                                    _vm.$_.get(
                                                      _vm.previewSettings,
                                                      "stackBy.expandMode",
                                                      "vertical"
                                                    ) === "horizontal"
                                                      ? "primary"
                                                      : "default",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleExpandModeChange(
                                                      "horizontal"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("show_chart")]
                                                ),
                                                _vm._v(
                                                  "\n                                        Yatay\n                                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("a-form-item", { attrs: { label: "Y Ekseni" } }, [
                        _c(
                          "div",
                          { staticClass: "y-axis-settings" },
                          [
                            !_vm.isBubbleChart
                              ? _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      value: _vm.$_.get(
                                        _vm.previewSettings,
                                        "yAxis.calculationType"
                                      ),
                                    },
                                    on: {
                                      change:
                                        _vm.handleYAxisCalculationTypeChange,
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "count" } },
                                      [_vm._v("Kayıt Sayısı")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "sum" } },
                                      [_vm._v("Toplam")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "average" } },
                                      [_vm._v("Ortalama")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "median" } },
                                      [_vm._v("Medyan")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "min" } },
                                      [_vm._v("Minimum")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "max" } },
                                      [_vm._v("Maksimum")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isBubbleChart &&
                            _vm.$_.get(
                              _vm.previewSettings,
                              "yAxis.calculationType"
                            ) !== "count"
                              ? _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      value: _vm.$_.get(
                                        _vm.previewSettings,
                                        "yAxis.field"
                                      ),
                                      placeholder: "Sayısal alan seçiniz",
                                    },
                                    on: { change: _vm.handleYAxisFieldChange },
                                  },
                                  _vm._l(_vm.numericFields, function (field) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: field._id,
                                        attrs: { value: field._id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(field.name) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isBubbleChart
                              ? _c(
                                  "a-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      value: _vm.$_.get(
                                        _vm.previewSettings,
                                        "yAxis.field"
                                      ),
                                      placeholder: "Sayısal alan seçiniz",
                                    },
                                    on: { change: _vm.handleYAxisFieldChange },
                                  },
                                  _vm._l(_vm.numericFields, function (field) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: field._id,
                                        attrs: { value: field._id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(field.name) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.hasDateField
                        ? _c(
                            "a-form-item",
                            { attrs: { label: "Tarih Gruplandırma" } },
                            [
                              _c(
                                "div",
                                { staticClass: "date-grouping-settings" },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        value: _vm.$_.get(
                                          _vm.previewSettings,
                                          "dateGrouping.field"
                                        ),
                                        placeholder: "Tarih alanı seçiniz",
                                      },
                                      on: {
                                        change:
                                          _vm.handleDateGroupingFieldChange,
                                      },
                                    },
                                    _vm._l(_vm.dateFields, function (field) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: field._id,
                                          attrs: { value: field._id },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(field.name) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.$_.get(
                                    _vm.previewSettings,
                                    "dateGrouping.field"
                                  )
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "section-label mt-2" },
                                          [_vm._v("Gruplandırma Tipi:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              value: _vm.$_.get(
                                                _vm.previewSettings,
                                                "dateGrouping.type"
                                              ),
                                              placeholder:
                                                "Gruplandırma seçiniz",
                                            },
                                            on: {
                                              change: function (value) {
                                                return _vm.$_.set(
                                                  _vm.previewSettings,
                                                  "dateGrouping.type",
                                                  value
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "day" } },
                                              [_vm._v("Günlük")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "week" } },
                                              [_vm._v("Haftalık")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "month" } },
                                              [_vm._v("Aylık")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "quarter" } },
                                              [_vm._v("3 Aylık")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "year" } },
                                              [_vm._v("Yıllık")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a-collapse",
                        [
                          _c(
                            "a-collapse-panel",
                            { attrs: { header: "Özelleştirme Ayarları" } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "Etiket ve Renk Özelleştirme",
                                  },
                                },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "dashed", block: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showLabelCustomizationModal = true
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("palette")]
                                      ),
                                      _vm._v(
                                        "\n                                    Etiket ve Renkleri Özelleştir\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-form-item",
                                { attrs: { label: "Sıralama" } },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        value: _vm.$_.get(
                                          _vm.previewSettings,
                                          "customization.sortBy"
                                        ),
                                      },
                                      on: { change: _vm.handleSortByChange },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "y-axis-asc" } },
                                        [_vm._v("Y Ekseni (Artan)")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "y-axis-desc" } },
                                        [_vm._v("Y Ekseni (Azalan)")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "x-axis-asc" } },
                                        [_vm._v("X Ekseni (Artan)")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "x-axis-desc" } },
                                        [_vm._v("X Ekseni (Azalan)")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-form-item",
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      attrs: {
                                        checked: _vm.$_.get(
                                          _vm.previewSettings,
                                          "customization.showEmptyValues",
                                          false
                                        ),
                                      },
                                      on: {
                                        change: function (e) {
                                          return _vm.handleShowEmptyValuesChange(
                                            e.target.checked
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Boş değerleri göster\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-form-item",
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      attrs: {
                                        checked: _vm.$_.get(
                                          _vm.previewSettings,
                                          "customization.showOnlyEnabled",
                                          false
                                        ),
                                      },
                                      on: {
                                        change: function (e) {
                                          return _vm.handleShowOnlyEnabledChange(
                                            e.target.checked
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Gösterim limiti uygula\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.$_.get(
                                _vm.previewSettings,
                                "customization.showOnlyEnabled"
                              )
                                ? _c(
                                    "a-form-item",
                                    { attrs: { label: "Gösterim Limiti" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "show-only-settings" },
                                        [
                                          _c(
                                            "a-select",
                                            {
                                              staticStyle: { width: "120px" },
                                              attrs: {
                                                value: _vm.$_.get(
                                                  _vm.previewSettings,
                                                  "customization.showOnly.mode"
                                                ),
                                              },
                                              on: {
                                                change:
                                                  _vm.handleShowOnlyModeChange,
                                              },
                                            },
                                            [
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "top" } },
                                                [_vm._v("İlk")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a-select-option",
                                                { attrs: { value: "bottom" } },
                                                [_vm._v("Son")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("a-input-number", {
                                            attrs: {
                                              value: _vm.$_.get(
                                                _vm.previewSettings,
                                                "customization.showOnly.take"
                                              ),
                                              min: 1,
                                              max: 100,
                                            },
                                            on: {
                                              change:
                                                _vm.handleShowOnlyTakeChange,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isPieOrDonutChart
                        ? _c(
                            "a-collapse",
                            [
                              _c(
                                "a-collapse-panel",
                                { attrs: { header: "Benchmark Çizgileri" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "benchmark-lines" },
                                    [
                                      _vm._l(
                                        _vm.previewSettings.benchmarkLines,
                                        function (line, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass:
                                                "benchmark-line-item",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "line-row" },
                                                [
                                                  _c("a-input", {
                                                    staticStyle: {
                                                      width: "200px",
                                                    },
                                                    attrs: {
                                                      placeholder: "Etiket",
                                                    },
                                                    model: {
                                                      value: line.label,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          line,
                                                          "label",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "line.label",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("a-input", {
                                                    staticStyle: {
                                                      width: "200px",
                                                    },
                                                    attrs: {
                                                      placeholder: "Açıklama",
                                                    },
                                                    model: {
                                                      value: line.text,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          line,
                                                          "text",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "line.text",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "line-row" },
                                                [
                                                  _c("a-input-number", {
                                                    staticStyle: {
                                                      width: "150px",
                                                    },
                                                    attrs: {
                                                      placeholder: "Değer",
                                                    },
                                                    model: {
                                                      value: line.value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          line,
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "line.value",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-select",
                                                    {
                                                      staticStyle: {
                                                        width: "150px",
                                                      },
                                                      model: {
                                                        value: line.axis,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            line,
                                                            "axis",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "line.axis",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: { value: "x" },
                                                        },
                                                        [_vm._v("X Ekseni")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: { value: "y" },
                                                        },
                                                        [_vm._v("Y Ekseni")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("a-input", {
                                                    staticStyle: {
                                                      width: "50px",
                                                    },
                                                    attrs: { type: "color" },
                                                    model: {
                                                      value: line.color,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          line,
                                                          "color",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "line.color",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-button",
                                                    {
                                                      attrs: { type: "link" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.removeBenchmarkLine(
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                        },
                                                        [_vm._v("delete")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { type: "dashed", block: "" },
                                          on: { click: _vm.addBenchmarkLine },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("add")]
                                          ),
                                          _vm._v(
                                            "\n                                    Benchmark Çizgisi Ekle\n                                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v("İptal")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.handleSave },
                },
                [_vm._v(" Kaydet ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showLabelCustomizationModal
        ? _c("label-color-customization", {
            attrs: {
              visible: _vm.showLabelCustomizationModal,
              "chart-type": _vm.previewSettings.chartType,
              "preview-data": _vm.previewData,
              fields: _vm.fields,
              settings: _vm.previewSettings,
            },
            on: {
              "update:visible": function ($event) {
                _vm.showLabelCustomizationModal = $event
              },
              save: _vm.handleLabelCustomizationSave,
              change: _vm.handleLabelCustomizationChange,
              close: function ($event) {
                _vm.showLabelCustomizationModal = false
              },
              cancel: function ($event) {
                _vm.showLabelCustomizationModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }